import { getUserRegion } from "src/utils/detectEnv";
import type { SiteDetail } from "src/store/dataSlice";

// TODO: remove once DAMMY_SITE dummy data is no longer needed for local/manual testing.
export const DUMMY_SITE_NAME = "Z-DummySite-ERGOU";

// Process path names and activity lists below are copied from real data
// (Partner Prep, Sort, RC Pick Library, Pack Support, Each Receive) so the
// dummy site behaves like a real one downstream.
export const DUMMY_PROCESS_PATHS: Record<string, string[]> = {
  "Partner Prep": [
    "Handle standard Product",
    "Operate Label Dispenser - Dispenser Equipment",
    "Place Product into Totes",
    "Use Hand Scanner - Scanning Equipment",
  ],
  "RC Pick Library": [
    "Handle empty Totes",
    "Handle full Totes",
    "Handle hazardous Product",
    "Retrieve Product from Shelving",
    "Use Hand Scanner - Scanning Equipment",
    "Use Mobile Ladder - Access or reaching equipment",
  ],
  "Pack Support": [
    "Adjust adjustable work table / station",
    "Apply sticker/label",
    "Handle standard Product",
    "Move Computer on Wheels - COW",
    "Operating in assigned work area",
    "Retrieve Product from Conveyance",
    "Use Hand Scanner - Scanning Equipment",
  ],
  "Each Receive": [
    "Apply sticker/label",
    "Carry Product or Bag",
    "Handle hazardous Product",
    "Handle standard Product",
    "Interaction with Control Panel",
    "Jam clearing / jam busting conveyor",
    "Move Computer on Wheels - COW",
  ],
};

export const getDummySiteDetail = (): SiteDetail => ({
  site: DUMMY_SITE_NAME,
  org: "GCF",
  suborg: "NACF",
  siteType: "Traditional Sortable Softlines",
  country: "US",
  region: getUserRegion(),
  processPath: DUMMY_PROCESS_PATHS,
});
